<style scoped >
.amount-due {
  border: solid 1px #ccc;
  text-align:center;
  width: 200px;
  padding: 0px;
}
.amount-due.paid {
  border: solid 1px #1b9e1b;
}
.amount-due .metric {
  font-size: 150%;
  font-weight: bold;
  padding:5px;
}
</style>
<template>
<v-card color='grey lighten-4'>
  <v-card-title class='subtitle-1 overline py-0' >
    <v-icon class='mr-1' >mdi-file-document-outline</v-icon>
    Invoices
    <v-spacer />
    <v-switch v-model="isPaid" label="Paid" :color='invoiceColor' />
    <v-divider vertical class='ml-4 mr-2' />
    <v-btn @click="getSettings" icon >
      <v-icon >mdi-reload</v-icon>
    </v-btn>
  </v-card-title>

  <v-alert dense text
    border="left" type="info" class='caption' >
    This shows a rough estimation of the data which will pull through onto your invoices
  </v-alert>

  <v-card class='elevation-10 ma-10' >
    <!-- <v-card-title >Invoice preview</v-card-title> -->
    <v-card-text >
      <v-overlay absolute v-if='req.loading' class='text-center' >
        <v-progress-circular size="70" color="amber" indeterminate />
        <br/>
        Loading settings
      </v-overlay>
      <v-row >
        <v-col cols=6 class='text-left pl-10' >
          <!-- <v-btn small
            color="warning"
             >Preview</v-btn><br/> -->
          <!-- {{profile.logo_picture}} -->
          <img
            v-if='profile.logo_picture'
            :src='profile.logo_picture'
            style="max-width:300px; max-height:150px;" />
          <div class='mt-3'>
            <strong v-if='profile.practice_name' >{{profile.practice_name}}</strong><br/>
            <template v-if='profile.practice_number' >
              <strong >Practice number:</strong> {{profile.practice_number}}
            </template>
          </div>
          <pre class='caption' v-text='profile.billing_address' />
          <div class='amount-due mt-3' >
            <strong>Amount due: </strong>
            <div v-if='isPaid' class='metric'>
              R0.00
            </div>
            <div v-else class='metric'>
              R1 000.00
            </div>
            <div v-if='isPaid' class='status success white--text caption' >
              ✓ PAID
            </div>
          </div>
        </v-col>
        <v-col cols=6 class='text-right pr-10' >
          <v-chip label >INV-12345</v-chip>
          <div class='mt-2'>
            <strong>Date:</strong> {{dt}}<br/>
            <strong>Due date:</strong> {{dt}}
          </div>
          <div class='mt-4 justify-right' >
            <strong class='overline'>Billing address</strong><br/>
            <v-skeleton-loader
              boilerplate
              class="ml-auto mt-2"
              max-width="120"
              type="text, text" />
          </div>
          <div
            v-if='profile.integrate_medical_aid'
            class='mt-4 justify-right' >
            <strong class='overline' >Medical Aid:</strong><br/>
            <v-skeleton-loader
              boilerplate
              class="ml-auto mt-2"
              max-width="120"
              type="text, text" />
            <div class='mt-2' >
              <strong>Patient referred by:</strong> Dr J Soap
            </div>
            <div>
              <strong>Summary of ICD10 codes used:</strong>
              M.25, M25.4, M25.45
            </div>
          </div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col cols='12' class='px-10' >
          <v-skeleton-loader
            boilerplate
            type="table-heading, table-thead, table-row-divider@1, table-tfoot" />
        </v-col>
      </v-row>
      <v-row >
        <v-col cols=6 class='text-left pl-10' >
          <strong>Banking details</strong>
          <pre class='caption' v-text='profile.banking_details' />
        </v-col>
        <v-col cols=6 class='text-right pl-10' >
          <template v-if='yocoLink' >
            <strong class='mr-7'>Pay online with</strong><br/>
            <a :href='yocoLink' target='_blank' >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <img v-on='on' v-bind='attrs'
                    src='https://ik.imagekit.io/appointmentguru/partners/yoco/yoco-150x80.jpeg' width="150" height="80" />
                </template>
                <span>
                  Will open your Yoco payment page:<br/>{{yocoLink}}
                </span>
              </v-tooltip>
            </a>
          </template>
        </v-col>
        <v-col v-if='isPaid && profile.receipt_notes' cols=12 class='text-left pl-10' >
          <strong>Notes</strong><br/>
          {{profile.receipt_notes}}
        </v-col>
        <v-col v-if='!isPaid && profile.invoice_notes' cols=12 class='text-left pl-10' >
          <strong>Notes</strong><br/>
          {{profile.invoice_notes}}
        </v-col>
      </v-row>
    </v-card-text>
    <v-footer color='teal caption white--text justify-center' >
      Book your next appointment online at: https://bookme.guru/{{profile.sub_domain}}/
    </v-footer>
    <div class='caption grey--text pl-10' >Page 1 of 1. Powered by AppointmentGuru</div>
    <!-- <pre v-text='profile.payment_configuration' class='caption' /> -->
  </v-card>

  <br/>
</v-card>
</template>
<script>
export default {
  name: 'Invoices',
  props: {
    value: { type: Object }
  },
  data () {
    return {
      req: {
        resource: 'ag.practitioner.profile.smartsettings'
      },
      isPaid: false
    }
  },
  methods: {
    getSettings () {
      if ( this.spaceId) {
        this.req.params = {space: this.spaceId}
        this.$request('get', this.req)
      }
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.getSettings()
      }
    }
  },
  computed: {
    space () { return this.value },
    spaceId () { return this.getObjectPath(this.space, 'id') },
    settings () { return this.getObjectPath(this.req, 'result', {}) },
    profile () { return this.getObjectPath(this.settings, 'profile', {}) },
    yocoLink () { return this.getObjectPath(this.profile, 'payment_configuration.yoco.link') },
    invoiceColor () { if (this.isPaid) { return 'green' } else { return 'grey' } },
    dt () {
      return new Date().toDateString()
    }
  }
}
</script>
